import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-success-alert-dialog',
  templateUrl: './success-alert-dialog.component.html',
  styleUrls: ['./success-alert-dialog.component.scss'],
})
export class SuccessAlertDialogComponent implements OnInit {
  public message!: any;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) private data: any) {}

  ngOnInit(): void {
    this.message = this.data;
  }

  public confirm() {
    this.dialogRef.close(true);
  }

  public close() {}
}
